module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAArklEQVQoU2NkQANPvKwMmJmY/EHCf//92yiz7dgFZCWMIM79AAcBjr9/9cES//4lMDAxLUBn/2Bmvqi44cAHZA0TGP7/hyhEB4yMCT+YmQvgGkDyz31sGiS3HGl45msbwMjMDHHGnz8KkluOHIDJgYTANiBrAEkyMDAcgAo7gAwZ/hp8bRP+/v0LDiVmZmYDyc2HF+D1NLZowKoBHP7//xtg0/CfkfGC1ObDG0ByADSWkQ0GVr4TAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/delete.png
// module id = 4b9t
// module chunks = 2